import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import ScrollFloat from './ScrollFloat';
import './Features.css';

const Features = () => {
  const [sectionRef, isVisible] = useScrollAnimation({ threshold: 0.1 });
  const features = [
    {
      title: 'Microsoft Teams Integration',
      description: 'Seamlessly integrated into Microsoft Teams where your employees already work. No new tools to learn—just ask questions in Teams.'
    },
    {
      title: 'Instant Knowledge Access',
      description: 'Employees get immediate answers from your knowledge base without manual searching through documents.'
    },
    {
      title: 'Tailored to Your Company',
      description: 'Customized to understand your specific processes, policies, and company culture.'
    },
    {
      title: 'Lightning Fast Responses',
      description: 'Get accurate information in seconds, not minutes. Boost productivity across your organization.'
    },
    {
      title: 'Secure & Private',
      description: 'Your data stays within your organization. Enterprise-grade security and privacy protection.'
    },
    {
      title: 'Continuous Learning',
      description: 'The chatbot learns from your knowledge base updates, ensuring it always has the latest information.'
    }
  ];

  return (
    <section id="features" className="features">
      <div ref={sectionRef} className={`features-container ${isVisible ? 'animate-in' : ''}`}>
        <div className="section-header">
          <h2 className="section-title">
            <ScrollFloat speed={0.3} direction="up">Powerful Features</ScrollFloat>
          </h2>
          <p className="section-subtitle">
            <ScrollFloat speed={0.2} direction="up">
              Everything you need to transform how your employees access information
            </ScrollFloat>
          </p>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card" style={{ transitionDelay: `${index * 0.1}s` }}>
              <h3 className="feature-title">
                <ScrollFloat speed={0.15 + (index * 0.05)} direction="up">{feature.title}</ScrollFloat>
              </h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;

